import type {
  YachtDice,
  YachtGameState,
  YachtRollCount,
  YachtRollDiceAction,
} from "../types";
import { rollDie } from "../utils";

function nextRollCount(rollCount: YachtRollCount): YachtRollCount {
  return Math.min(3, rollCount + 1) as YachtRollCount;
}

export function applyRollDice(
  state: YachtGameState,
  action: YachtRollDiceAction,
): YachtGameState {
  const slot = state.turnSlotsByPlayerId[action.playerId];
  if (!slot) return state;

  let rngState = slot.rngState;
  const nextDice = slot.dice.map((currentDie, index) => {
    const shouldRoll = slot.rollCount === 0 || !slot.held[index];
    if (!shouldRoll) return currentDie;

    const roll = rollDie(rngState);
    rngState = roll.rngState;
    return roll.value;
  }) as unknown as YachtDice;

  return {
    ...state,
    turnSlotsByPlayerId: {
      ...state.turnSlotsByPlayerId,
      [action.playerId]: {
        ...slot,
        dice: nextDice,
        rollCount: nextRollCount(slot.rollCount),
        rngState,
      },
    },
  };
}
